import { Icon } from './Icon';

/** Питомцы: отпечаток лапы. */
export function PawIcon({ size = 20 }: { size?: number }) {
  return (
    <Icon size={size} box={20}>
      <path d="M5.6 12.6 q4.4 -5.2 8.8 0 q1.2 4 -4.4 4 q-5.6 0 -4.4 -4 Z" />
      <ellipse cx="5.4" cy="6.6" rx="1.8" ry="2.4" />
      <ellipse cx="14.6" cy="6.6" rx="1.8" ry="2.4" />
    </Icon>
  );
}
